const ExclamationIcon = props => (
  <svg
    width={44}
    height={44}
    viewBox="0 0 44 44"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5999 22.0004C39.5999 26.6682 37.7456 31.1448 34.445 34.4455C31.1443 37.7461 26.6677 39.6004 21.9999 39.6004C17.3321 39.6004 12.8555 37.7461 9.55482 34.4455C6.25418 31.1448 4.3999 26.6682 4.3999 22.0004C4.3999 17.3326 6.25418 12.856 9.55482 9.55531C12.8555 6.25467 17.3321 4.40039 21.9999 4.40039C26.6677 4.40039 31.1443 6.25467 34.445 9.55531C37.7456 12.856 39.5999 17.3326 39.5999 22.0004V22.0004ZM24.1999 30.8004C24.1999 31.3839 23.9681 31.9434 23.5555 32.356C23.143 32.7686 22.5834 33.0004 21.9999 33.0004C21.4164 33.0004 20.8568 32.7686 20.4443 32.356C20.0317 31.9434 19.7999 31.3839 19.7999 30.8004C19.7999 30.2169 20.0317 29.6573 20.4443 29.2448C20.8568 28.8322 21.4164 28.6004 21.9999 28.6004C22.5834 28.6004 23.143 28.8322 23.5555 29.2448C23.9681 29.6573 24.1999 30.2169 24.1999 30.8004V30.8004ZM21.9999 11.0004C21.4164 11.0004 20.8568 11.2322 20.4443 11.6448C20.0317 12.0573 19.7999 12.6169 19.7999 13.2004V22.0004C19.7999 22.5839 20.0317 23.1434 20.4443 23.556C20.8568 23.9686 21.4164 24.2004 21.9999 24.2004C22.5834 24.2004 23.143 23.9686 23.5555 23.556C23.9681 23.1434 24.1999 22.5839 24.1999 22.0004V13.2004C24.1999 12.6169 23.9681 12.0573 23.5555 11.6448C23.143 11.2322 22.5834 11.0004 21.9999 11.0004Z"
    />
  </svg>
)

export default ExclamationIcon
